import request from '@/utils/request'

export function updateShareCfg(data) {
  return request({
    url: 'api/v1/share-cfg/update',
    method: 'post',
    data: data
  })
}

export function getShareCfgList(data) {
  return request({
    url: 'api/v1/share-cfg/getList',
    method: 'post',
    data: data
  })
}

export function getShareCfg(data) {
  return request({
    url: 'api/v1/share-cfg/shareConfig',
    method: 'get'
  })
}

export function uploadCdn(data) {
  return request({
    url: 'api/v1/share-cfg/uploadCdn',
    method: 'post',
    data: data
  })
}

export function importShareCfg(data) {
  return request({
    url: 'api/v1/share-cfg/import',
    method: 'post',
    data: data
  })
}

export function delShareCfg(data) {
  return request({
    url: 'api/v1/share-cfg/del',
    method: 'post',
    data: data
  })
}

export function exportShareCfg() {
  return request({
    url: 'api/v1/share-cfg/export',
    method: 'post'
  })
}
